module.exports = __webpack_public_path__ + "img/fx.0364380e.png";